<template>
  <dialogTemplate
    :widthDialog="'450px'"
    :modalAppendToBody="true"
    :appendToBody="true"
    :openDialog="openDialog"
    :classDialog="'dialogRedirect'"
    :showCloseBtn="false"
  >
    <template #body>
      <div class="flex-row flex__left">
        <i
          alt=""
          class="dialogIcon fas fa-exclamation-triangle color__yellow"
        ></i>
        <h3 class="dialogTitle margin-left-5"> WARNING !</h3>
      </div>
      <div>
        <p style="word-break: break-word;">{{content}}</p>
        <p>Hệ thống sẽ tự động chuyển trang trong {{countDown}} giây ...</p>
        <br/>
      </div>
    </template>
    <template #footer>
      <div class="flex-row flex__center form-button__action">
        <el-button
          class="bg__yellow color__white"
          @click="backToLogin"
        >
          Về trang đăng nhập
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>

<script>
  import authenService from "../services/authenService";
  import constants from "../constants";
  import VueCookies from 'vue-cookies';

  export default {
    name: "DialogHandlerError",

    components: {
      dialogTemplate: () => import('./../views/common/custom-dialog.vue')
    },

    props: ["content", "openDialog", "title"],

    data() {
      return {
        countDown: 10,
      }
    },

    created() {
      this.subCountDown();
    },

    methods: {
      backToLogin() {
        authenService.removeToken().then(() => {
          let client_id = encodeURIComponent(constants.SSO_CLIENT_ID);
          let redirect_uri = encodeURIComponent(constants.SSO_LOGOUT_CALLBACK);
          VueCookies.remove("IdHash");
          window.location.href = `${
            constants.SSO_URL_LOGOUT
          }?client_id=${client_id}&redirect_uri=${redirect_uri}`;
        });
      },

      subCountDown() {
        setInterval(() => {
          if (this.countDown > 1) {
            this.countDown -= 1;
          } else {
            this.backToLogin();
            this.countDown -= 1;
          }
        }, 1000)
      }

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DialogHandlerError.vue